let prefix = "franchisees"

export default {
    taxRates: () => axios.get(`/${prefix}/tax_rates`),
    pricingOptions: () => axios.get(`/${prefix}/pricingOptions`),
    financingOptions: () => axios.get(`/${prefix}/financingOptions`),
    productPrices: () => axios.get(`/${prefix}/productPrices`),
}
